import { useThemeSlice } from "../ui/StatusBadge.jsx";
import { SkeletonBlock } from "./SkeletonBlock.jsx";
import { EntityTableBodySkeleton } from "./EntityTableBodySkeleton.jsx";

export function TypeCatalogRouteSkeleton() {
  const { c, dark } = useThemeSlice();

  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0, overflow: "hidden", padding: 14 }}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 12, marginBottom: 14 }}>
        <div style={{ flex: 1 }}>
          <SkeletonBlock width={160} height={18} style={{ marginBottom: 8 }} />
          <SkeletonBlock width={320} height={12} />
        </div>
        <SkeletonBlock width={140} height={34} radius={8} />
      </div>
      <div
        style={{
          background: c.card,
          border: `1px solid ${c.cardBdr}`,
          borderRadius: 12,
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          boxShadow: dark ? "0 8px 24px rgba(0,0,0,.2)" : "0 8px 24px rgba(15,23,42,.06)",
        }}
      >
        <div style={{ padding: "12px 14px", borderBottom: `1px solid ${c.divider}` }}>
          <SkeletonBlock width="100%" height={34} style={{ maxWidth: 300 }} />
        </div>
        <EntityTableBodySkeleton />
      </div>
    </div>
  );
}
